import React from 'react';
import { Link } from 'react-router';

import getUrl from '@/routes/routes/helpers/getUrl';
import { submitResultNotification, overflowText } from './styles.module.css';

const SubmitResultNotification = ({
  bookingId,
  eventId,
  eventTitle,
  onClick,
}) => {
  return (
    <div className={submitResultNotification}>
      <div className={overflowText}>
        {"It's time to "}
        <b>
          <Link
            onClick={onClick}
            to={getUrl.bookingSubmitResultPage(eventId, bookingId)}
          >
            Submit your results
          </Link>
        </b>{' '}
        for {eventTitle}
      </div>
    </div>
  );
};

const SubmitResultNotificationList = ({ submitResultEvents, onClick }) => {
  if (!submitResultEvents?.length) return null;

  return (
    <div>
      {submitResultEvents.map(({ bookingId, eventSummary }) => (
        <SubmitResultNotification
          key={`submit-results-notification-${eventSummary?.eventId}-${bookingId}`}
          bookingId={bookingId}
          eventId={eventSummary?.eventId}
          eventTitle={eventSummary?.title}
          onClick={onClick}
        />
      ))}
    </div>
  );
};

export default SubmitResultNotificationList;
